import { markRaw } from "vue";

import type { PiniaPluginContext } from "pinia";
import type { RouteLocationNormalizedLoadedGeneric, Router } from "vue-router";

export function routerPlugin(router: Router) {
  return (context: PiniaPluginContext) => {
    context.store.router = markRaw(router);
    context.store.currentRoute = router.currentRoute.value;

    // beforeResolve (not beforeEach) so to receive the settled route
    router.beforeResolve((to) => {
      context.store.currentRoute = to;
      return true;
    });
  };
}

declare module "pinia" {
  export interface PiniaCustomProperties {
    router: Omit<Router, "currentRoute">;
    currentRoute: RouteLocationNormalizedLoadedGeneric;
  }
}
